<template>
    <div class="content accident-page">
        <div class="content_box public_box">
            <div class="page-heading">
                <h2>运营事故</h2>
                <span>运营平台上报的事故记录</span>
            </div>
            <div class="search_box">
                <el-form :inline="true" :model="filters" size="small" @submit.native.prevent="queryListData">
                    <el-form-item label="车牌号：">
                        <el-input v-model="filters.plateNo" class="vehicle-input" placeholder="请输入车牌号" clearable @keyup.enter.native="queryListData" />
                    </el-form-item>
                    <el-form-item label="车架号：">
                        <el-input v-model="filters.vin" class="vehicle-input" placeholder="请输入车架号" clearable @keyup.enter.native="queryListData" />
                    </el-form-item>
                    <el-form-item label="出险时段：">
                        <el-date-picker
                            v-model="filters.accidentTimeRange"
                            class="time-range-input"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            clearable
                        />
                    </el-form-item>
                    <el-form-item label="事故信息同步：">
                        <el-select v-model="filters.syncStatus" class="status-input" placeholder="全部" clearable>
                            <el-option v-for="item in syncStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="queryListData">查询</el-button>
                        <el-button @click="resetQuery">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <el-alert v-if="errorMessage" class="request-error" :title="errorMessage" type="error" show-icon :closable="false">
                <el-button type="text" size="small" :disabled="tableLoading" @click="getTableData">重新加载</el-button>
            </el-alert>
            <el-table v-loading="tableLoading" :data="tableData" row-key="id" border stripe :empty-text="errorMessage ? '数据加载失败，请重试' : '暂无运营上报的事故记录'">
                <el-table-column type="index" :index="rowIndex" label="序号" width="65" align="center" fixed="left" />
                <el-table-column prop="plateNo" label="车牌号" width="115" fixed="left" :formatter="formatCell" />
                <el-table-column prop="vin" label="车架号" min-width="180" show-overflow-tooltip :formatter="formatCell" />
                <el-table-column prop="deviceNumber" label="设备号" min-width="150" show-overflow-tooltip :formatter="formatCell" />
                <el-table-column prop="subTenantName" label="所属车队" min-width="160" show-overflow-tooltip :formatter="formatCell" />
                <el-table-column prop="insuranceCaseNo" label="报案号" min-width="180" show-overflow-tooltip :formatter="formatCell" />
                <el-table-column prop="accidentTime" label="出险时间" width="165" :formatter="formatCell" />
                <el-table-column prop="realAccidentTime" label="实际出险时间" width="165" :formatter="formatCell" />
                <el-table-column label="录入时间" width="165">
                    <template slot-scope="scope">{{ recordTime(scope.row) }}</template>
                </el-table-column>
                <el-table-column label="事故信息同步" width="130" align="center">
                    <template slot-scope="scope">{{ syncStatusText(scope.row) }}</template>
                </el-table-column>
                <el-table-column prop="accidentAddress" label="事故地点" min-width="200" show-overflow-tooltip :formatter="formatCell" />
                <el-table-column prop="accidentCause" label="事故原因" min-width="200" show-overflow-tooltip :formatter="formatCell" />
                <el-table-column label="操作" width="95" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="showDetail(scope.row)">查看详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                class="pagination"
                :current-page="pageNo"
                :page-size="pageSize"
                :page-sizes="[10, 20, 50]"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
            />
        </div>

        <el-dialog title="运营事故详情" :visible.sync="detailVisible" width="80%" top="5vh" append-to-body @closed="detail = null">
            <div v-loading="detailLoading" class="detail-container">
            <div v-if="detail" class="accident-detail">
                <el-descriptions :column="3" border size="small">
                    <el-descriptions-item label="车牌号">{{ displayValue(detail.plateNo) }}</el-descriptions-item>
                    <el-descriptions-item label="车架号">{{ displayValue(detail.vin) }}</el-descriptions-item>
                    <el-descriptions-item label="设备号">{{ displayValue(detail.deviceNumber) }}</el-descriptions-item>
                    <el-descriptions-item label="所属公司">{{ displayValue(detail.rootTenantName) }}</el-descriptions-item>
                    <el-descriptions-item label="所属车队">{{ displayValue(detail.subTenantName) }}</el-descriptions-item>
                    <el-descriptions-item label="报案号">{{ displayValue(detail.insuranceCaseNo) }}</el-descriptions-item>
                    <el-descriptions-item label="出险时间">{{ displayValue(detail.accidentTime) }}</el-descriptions-item>
                    <el-descriptions-item label="实际出险时间">{{ displayValue(detail.realAccidentTime) }}</el-descriptions-item>
                    <el-descriptions-item label="录入时间">{{ recordTime(detail) }}</el-descriptions-item>
                    <el-descriptions-item label="信息来源">运营上报</el-descriptions-item>
                    <el-descriptions-item label="事故信息同步">{{ syncStatusText(detail) }}</el-descriptions-item>
                    <el-descriptions-item label="视频状态">{{ displayValue(detail.videoExtractionStatusDesc) }}</el-descriptions-item>
                    <el-descriptions-item label="是否人伤">{{ booleanText(detail.hasInjury) }}</el-descriptions-item>
                    <el-descriptions-item label="气囊是否弹出">{{ booleanText(detail.airbagDeployed) }}</el-descriptions-item>
                    <el-descriptions-item label="是否短租车">{{ booleanText(detail.shortTermRental) }}</el-descriptions-item>
                    <el-descriptions-item label="是否已补充材料">{{ booleanText(detail.materialSupplemented) }}</el-descriptions-item>
                    <el-descriptions-item label="是否同车换驾">{{ displayValue(detail.changeDriving) }}</el-descriptions-item>
                    <el-descriptions-item label="视频提取时间">{{ displayValue(detail.videoExtractionTime) }}</el-descriptions-item>
                    <el-descriptions-item label="事故地点" :span="3">{{ displayValue(detail.accidentAddress) }}</el-descriptions-item>
                    <el-descriptions-item label="事故原因" :span="3">{{ displayValue(detail.accidentCause) }}</el-descriptions-item>
                    <el-descriptions-item label="备注" :span="3">{{ displayValue(detail.remark) }}</el-descriptions-item>
                </el-descriptions>
                <div class="video-heading">事故视频</div>
                <div v-if="detailVisible && (detail.frontCameraVideoUrl || detail.rearCameraVideoUrl)" class="video-list">
                    <div v-if="detail.frontCameraVideoUrl" class="video-item">
                        <p>车外视频</p>
                        <video :key="detail.frontCameraVideoUrl" :src="detail.frontCameraVideoUrl" controls preload="none" />
                    </div>
                    <div v-if="detail.rearCameraVideoUrl" class="video-item">
                        <p>车内视频</p>
                        <video :key="detail.rearCameraVideoUrl" :src="detail.rearCameraVideoUrl" controls preload="none" />
                    </div>
                </div>
                <el-empty v-else description="暂无事故视频" :image-size="60" />
            </div>
            </div>
            <span slot="footer"><el-button size="small" @click="detailVisible = false">关闭</el-button></span>
        </el-dialog>
    </div>
</template>

<script>
// AccidentSourceEnum.OPERATOR；与旧接口的 accidentDataType（手动录入）不同。
const OPERATOR_SOURCE = 4;
const createFilters = () => ({ plateNo: '', vin: '', accidentTimeRange: null, syncStatus: null });
const syncStatusLabels = {
    0: '待同步',
    1: '已同步',
    2: '自动同步',
    3: '未发生事故'
};

export default {
    name: 'OperatorAccidents',
    data() {
        return {
            filters: createFilters(),
            condition: {},
            pageNo: 1,
            pageSize: 10,
            total: 0,
            tableData: [],
            tableLoading: false,
            errorMessage: '',
            requestSequence: 0,
            detailVisible: false,
            detailLoading: false,
            detail: null,
            // 以服务端 AccidentSyncStatusEnum 为准，0 是有效的待同步状态。
            syncStatusOptions: [
                { value: 0, label: '待同步' },
                { value: 1, label: '已同步' },
                { value: 3, label: '未发生事故' }
            ]
        };
    },
    mounted() {
        this.queryListData();
    },
    beforeDestroy() {
        this.requestSequence++;
    },
    methods: {
        queryListData() {
            const accidentTimeRange = this.filters.accidentTimeRange || [];
            this.condition = {
                plateNo: this.filters.plateNo.trim() || null,
                vin: this.filters.vin.trim() || null,
                accidentTimeStart: accidentTimeRange[0] || null,
                accidentTimeEnd: accidentTimeRange[1] || null,
                syncStatusList: this.filters.syncStatus === '' || this.filters.syncStatus === null ? null : [this.filters.syncStatus],
                sourceList: [OPERATOR_SOURCE],
                operatorQuery: true
            };
            this.pageNo = 1;
            return this.getTableData();
        },
        resetQuery() {
            this.filters = createFilters();
            return this.queryListData();
        },
        async getTableData() {
            const sequence = ++this.requestSequence;
            this.tableLoading = true;
            this.errorMessage = '';
            this.tableData = [];
            try {
                const res = await this.$request({
                    method: 'POST',
                    url: '/ubi/api/lightning-report/operate/report-list',
                    data: {
                        condition: { ...this.condition },
                        orders: [],
                        pageNo: this.pageNo,
                        pageSize: this.pageSize
                    }
                });
                if (sequence !== this.requestSequence) return;
                if (!res || Number(res.code) !== 200 || !res.data || !Array.isArray(res.data.list)) {
                    throw new Error((res && (res.msg || res.message)) || '事故数据加载失败，请稍后重试');
                }
                this.tableData = res.data.list;
                this.total = Number(res.data.total) || 0;
            } catch (error) {
                if (sequence !== this.requestSequence) return;
                this.total = 0;
                this.errorMessage = error.message || '事故数据加载失败，请稍后重试';
            } finally {
                if (sequence === this.requestSequence) this.tableLoading = false;
            }
        },
        handleSizeChange(size) {
            this.pageSize = size;
            this.pageNo = 1;
            return this.getTableData();
        },
        handleCurrentChange(page) {
            if (page === this.pageNo) return;
            this.pageNo = page;
            return this.getTableData();
        },
        rowIndex(index) {
            return (this.pageNo - 1) * this.pageSize + index + 1;
        },
        async showDetail(row) {
            this.detailVisible = true;
            this.detailLoading = true;
            this.detail = null;
            try {
                const res = await this.$request({
                    method: 'GET',
                    url: `/ubi/api/lightning-report/operate/report-detail/${row.id}`
                });
                if (!res || Number(res.code) !== 200 || !res.data) {
                    throw new Error((res && (res.msg || res.message)) || '事故详情加载失败，请稍后重试');
                }
                this.detail = res.data;
            } catch (error) {
                this.detailVisible = false;
                this.$message.error(error.message || '事故详情加载失败，请稍后重试');
            } finally {
                this.detailLoading = false;
            }
        },
        displayValue(value) {
            return value === null || value === undefined || value === '' ? '--' : value;
        },
        formatCell(row, column, value) {
            return this.displayValue(value);
        },
        recordTime(row) {
            return row.recordCreateTime || row.createTime || row.smsTime || '--';
        },
        syncStatusText(row) {
            return row.syncStatusDesc || syncStatusLabels[row.syncStatus] || '--';
        },
        booleanText(value) {
            if (value === true || value === 1 || value === '1' || value === 'true') return '是';
            if (value === false || value === 0 || value === '0' || value === 'false') return '否';
            return '--';
        }
    }
};
</script>

<style scoped>
.accident-page {
    height: 100%;
    overflow: auto;
}
.page-heading {
    display: flex;
    align-items: baseline;
    gap: 16px;
    margin-bottom: 20px;
}
.page-heading h2 {
    margin: 0;
    font-size: 20px;
    color: #303133;
}
.page-heading span {
    font-size: 13px;
    color: #909399;
}
.vehicle-input {
    width: 240px;
}
.time-range-input {
    width: 360px;
}
.status-input {
    width: 130px;
}
.detail-container {
    min-height: 120px;
}
.request-error {
    margin-bottom: 16px;
}
.pagination {
    margin-top: 20px;
}
.accident-detail {
    white-space: pre-wrap;
    overflow-wrap: anywhere;
}
.video-heading {
    margin: 24px 0 12px;
    font-size: 16px;
    font-weight: 500;
}
.video-list {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
}
.video-item {
    flex: 1 1 320px;
    min-width: 0;
}
.video-item p {
    margin-bottom: 8px;
}
.video-item video {
    display: block;
    width: 100%;
    max-height: 360px;
    background: #000;
}
</style>
